import React from "react";
import { useAuth } from "../../utils/auth/useAuth";
import { Outlet } from "react-router-dom";


function PackagingLanding() {
	const { authState } = useAuth();
	
	if(authState?.isAuthenticated){
		return(
			
                <>
                    <Outlet/>
                </>
		)
	}
}

export default PackagingLanding;